export enum AccesosLoginEnum {
    Usuario = 'Administrador',
    Clave = '@dm|n2024+'
}
